import React from 'react'
import styled from 'styled-components'

import { SvgIconComponent } from 'components/Luxkit/SvgIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import { TypographyElement } from 'components/Luxkit/Typography/Typography'

const NoOverFlowBodyTextBlock = styled(BodyTextBlock)`
  ${TypographyElement} {
    overflow-wrap: anywhere;
  }
`

function ItemTitle({
  icon: Icon,
  children,
}: React.PropsWithChildren<{
  icon: SvgIconComponent
}>) {
  return (
    <NoOverFlowBodyTextBlock
      variant="medium"
      weight="bold"
      startIcon={<Icon size="S" />}
      lineClamp={2}
      wrap="pretty"
    >
      {children}
    </NoOverFlowBodyTextBlock>
  )
}

export default ItemTitle
